module.exports = __webpack_public_path__ + "static/img/report.4c2901d0.jpeg";